import React from 'react';
import { SvgIcon } from '@mui/material';
const SvgEnquire = (props) => (
  <SvgIcon {...props} title="Enquire">
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#enquire_svg__a)"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#017163"
      >
        <path d="M23.973 3.213a11.975 11.975 0 0 0-12.188 11.78V24a1.5 1.5 0 0 1-3 0v-9.04A14.974 14.974 0 0 1 24 .213a14.974 14.974 0 0 1 15.215 14.746v9.04a1.5 1.5 0 1 1-3 0v-9.006a11.973 11.973 0 0 0-12.188-11.78L24 1.713l-.026 1.5Z" />
        <path d="M5.143 20.36a1.929 1.929 0 0 0-1.928 1.928v6.857a1.929 1.929 0 0 0 1.928 1.929h3.429a.214.214 0 0 0 .214-.215V20.574a.214.214 0 0 0-.214-.215H5.143Zm0-3h3.429a3.214 3.214 0 0 1 3.214 3.214v10.285a3.214 3.214 0 0 1-3.214 3.215H5.143a4.929 4.929 0 0 1-4.928-4.929v-6.857a4.929 4.929 0 0 1 4.928-4.929ZM42.857 31.07a1.929 1.929 0 0 0 1.928-1.928v-6.857a1.929 1.929 0 0 0-1.928-1.929h-3.429a.214.214 0 0 0-.214.214v10.286a.214.214 0 0 0 .214.214h3.429Zm0 3h-3.429a3.214 3.214 0 0 1-3.214-3.214V20.57a3.214 3.214 0 0 1 3.214-3.214h3.429a4.929 4.929 0 0 1 4.928 4.929v6.857a4.929 4.929 0 0 1-4.928 4.928Z" />
        <path d="M37.717 25.93a1.5 1.5 0 0 1 1.5 1.5v7.714a8.358 8.358 0 0 1-8.358 8.357 1.5 1.5 0 1 1 0-3 5.357 5.357 0 0 0 5.358-5.357V27.43a1.5 1.5 0 0 1 1.5-1.5Z" />
        <path d="M21.43 39.21a2.786 2.786 0 0 0 0 5.572h5.143a2.785 2.785 0 1 0 0-5.571H21.43Zm-4.09-1.304a5.786 5.786 0 0 1 4.09-1.695h5.143a5.786 5.786 0 0 1 0 11.571H21.43a5.786 5.786 0 0 1-4.09-9.876Z" />
      </g>
      <defs>
        <clipPath id="enquire_svg__a">
          <path fill="#fff" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);
export default SvgEnquire;
